import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { X } from 'react-feather';
import { Link } from 'react-router-dom';

import * as constants from '../../constants/AppConstants';

import CreateChannel from '../CreateChannel/CreateChannelContainer';
import CreateDM from '../CreateDM/CreateDMContainer';
import MobileMenuToggle from '../MobileMenuToggle/MobileMenuToggleContainer';
import { isSafari, isFirefox } from 'react-device-detect';

/** Used to create a channel or a direct message. */
class CreatePanel extends Component {
  static propTypes = {
    title: PropTypes.string,
    qaId: PropTypes.string,
    type: PropTypes.string,
    isIframe: PropTypes.bool,
    previousRoute: PropTypes.string
  };

  constructor(props) {
    super(props);

    const defaultInvitedUsers = props.location.state && props.location.state.usersToInvite ? [props.location.state.usersToInvite] : [];
    this.state = {
      defaultInvitedUsers,
      pageTitle: 'Create a new conversation'
    }
  }

  componentDidMount() {
    this.buildPageTitle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      this.buildPageTitle();
    }
  }

  isChannel = type => type === constants.CHANNEL_TYPE;
  isDirectMessage = type => type === constants.DIRECT_MESSAGE_TYPE;

  buildPageTitle = () => {
    const { type } = this.props;
    this.isChannel(type) && this.setState({ pageTitle: 'Create a new channel' });
    this.isDirectMessage(type) && this.setState({ pageTitle: 'Create a new direct message' });
  };

  /**
   * On first page load, history.goBack() fails to work as expected for safari/firefox when messenger is in an iFrame
   * @returns {*}
   */
  renderCloseBtn = () => {
    const { previousRoute, isIframe } = this.props;

    if (isIframe && (isFirefox || isSafari)) {
      console.log('is iframe & safari/firefox');
      return (
        <Link
          to={previousRoute}
          className="closeButton"
          data-qa="goBackButton"
        >
          <X size={24}/>
        </Link>
      );
    } else {
      return (
        <button
          onClick={this.props.history.goBack}
          className="closeButton"
          data-qa="goBackButton"
        >
          <X size={24}/>
        </button>
      );
    }
  };

  render() {
    const { title, qaId, type } = this.props;
    const { defaultInvitedUsers, pageTitle } = this.state;
    return (
      <DocumentTitle title={pageTitle}>
        <div className="create-panel flex flex-column" data-qa={qaId}>
          <div className="panel-title">
            <MobileMenuToggle />
            <h1>{title}</h1>
            {this.renderCloseBtn()}
          </div>
          <div className="panel-content">
            {this.isDirectMessage(type) && <CreateDM defaultInvitedUsers={defaultInvitedUsers} />}
            {this.isChannel(type) && <CreateChannel />}
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default CreatePanel;
